import { render, staticRenderFns } from "./CumulativeFrequency_1.vue?vue&type=template&id=38b7aac0&scoped=true"
import script from "./CumulativeFrequency_1.vue?vue&type=script&lang=js"
export * from "./CumulativeFrequency_1.vue?vue&type=script&lang=js"
import style0 from "./CumulativeFrequency_1.vue?vue&type=style&index=0&id=38b7aac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b7aac0",
  null
  
)

export default component.exports